$.YPTC = $.YPTC || {};
$.YPTC.Delta = $.YPTC.Delta || {};
$.YPTC.Delta.DataStatus = $.YPTC.Delta.DataStatus || (function () {
    const
        state = {
            intervalCount: 0,
            normalInterval: 15 * 1000,
            refreshInterval: 1000,
            enabled: false,
            status_prev: null
        },
        dataStatusLive = function () {
            return document.getElementById('dataStatusLive');
        },
        init = function () {
            let e = document.getElementById('hdnDataStatus');
            if (e !== null && dataStatusLive() !== null) {
                state.enabled = true;
                watch(e);
            }

            let b = document.getElementById('btnLoadData');
            if (b !== null) b.addEventListener('click', load);
        },
        watch = function (e) {
            if (state.enabled) {
                let status = e.value;
                let transition = status == 'UpToDate' && state.status_prev !== null && state.status_prev != status;

                if (transition) location.reload(); // when status transitions to UpToDate, reload the page
                else state.status_prev = status;   // otherwise, pass the status forward

                state.timer = setTimeout(update, status == 'Loading' || status == 'Checking' ? state.refreshInterval : (state.normalInterval + (state.intervalCount++ * 1500)));
            }
        },
        update = function () {
            this.disabled = true;
            let url = dataStatusLive().dataset.statusUrl;
            handle(url);
        },
        load = function () {
            this.disabled = true;
            let url = dataStatusLive().dataset.loadUrl;
            handle(url);
        },
        handle = function (url) {
            fetch(url).then(function(res) { return res.text(); }).then(function(html) {
                state.enabled = true;

                let e = document.createElement('div');
                e.innerHTML = html;
                dataStatusLive().replaceWith(e.firstElementChild);

                init();
            }).catch(function (err) {
                state.enabled = false;
                console.log('Problem with data status check!', err);
            });
        };

    document.addEventListener('DOMContentLoaded', init);
})();